import React from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  useMediaQuery,
} from '@material-ui/core';
import { useStyles } from '../styles';
import CheckboxIcon from 'src/assets/icons/web/checkbox.svg';
import CheckboxCheckedIcon from 'src/assets/icons/web/checkboxChecked.svg';
import { useDispatch, useSelector } from 'react-redux';
import {
  calendarWeek,
  setWeek,
  tripData,
} from 'src/redux/Calendar/sliceCalendar';

export const weekValues = [
  {
    id: 7,
    label: 'Sunday',
    mLabel: 'Sun',
  },
  {
    id: 1,
    label: 'Monday',
    mLabel: 'Mon',
  },
  {
    id: 2,
    label: 'Tuesday',
    mLabel: 'Tue',
  },
  {
    id: 3,
    label: 'Wednesday',
    mLabel: 'Wed',
  },
  {
    id: 4,
    label: 'Thursday',
    mLabel: 'Thu',
  },
  {
    id: 5,
    label: 'Friday',
    mLabel: 'Fri',
  },
  {
    id: 6,
    label: 'Saturday',
    mLabel: 'Sat',
  },
];

export const WeekBlock = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery('(max-width: 960px)');
  const week = useSelector(calendarWeek);
  const data = useSelector(tripData);

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      mt={4}
      style={{
        gap: '10px',
      }}>
      {weekValues.map((i, index) => (
        <Box key={index} className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                key={i.id}
                name={i.label}
                icon={<CheckboxIcon />}
                checkedIcon={<CheckboxCheckedIcon />}
                checked={!!week?.includes(i.id)}
                onChange={() => dispatch(setWeek(i.id))}
                disabled={!data?.weekly?.split(',').includes(i.id.toString())}
              />
            }
            label={isMobile ? i.mLabel : i.label}
          />
        </Box>
      ))}
    </Box>
  );
};
